import { TFormField } from '@/interfaces/form'
import { Button, Col, Form, Upload } from 'antd'

import './styles.scss'
import { FaUpload } from 'react-icons/fa6'
import { TFieldProps } from '..'

export default function UploadImageFormField({
  fieldInfo,
  subsectionForm = false,
}: TFieldProps) {
  return (
    <Col xl={subsectionForm ? 24 : 8} md={subsectionForm ? 24 : 12} xs={24}>
      <Form.Item
        className={`upload-image-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
      >
        <Upload accept='image/*' listType='picture-card' maxCount={1}>
          <Button className='upload-image-btn' icon={<FaUpload />} />
        </Upload>
      </Form.Item>
    </Col>
  )
}
